class StoreUpdator extends HTMLElement {
    constructor() {
      super();
      this.current_store_id = localStorage.getItem('global_store_id');
      this.store_search = document.getElementById('store_update_search');
      this.store_list    = this.querySelector('.store-search-dropdown-content');
      this.store_dropdown = this.querySelector('.store-search_dropdown');
      this.mobile_popup_button = document.querySelector('.header__location-data--mobile');
  
  
      this.appendStoreElements = this.appendStoreElements.bind(this);
      this.handleStoreSearch = this.handleStoreSearch.bind(this);
      // this.handleStoreList = this.handleStoreList.bind(this);
    }
  
    connectedCallback() {
      this.current_store_title = this.querySelector('.js-current__store-title');
      this.store_distance = this.querySelector('.js-current__store-distance');
      this.store_address = this.querySelector('.js-current__store-address');
  
      this.handleStoreList();
      this.handleStoreUpdate();
      this.handleShopHere();
  
      // this.mobile_popup_button.querySelector('.js-header-store-name').innerHTML = "Change Your Store";
      // this.mobile_popup_button.querySelector('.js-header-street').innerHTML = "";
      if (this.current_store_title) {
        this.setCurrentStoreDetails();
      } else {
        console.error("StoreUpdator: .js-current__store-title not found");
      }
  
      if (this.store_search) {
        this.store_search.addEventListener('input', this.handleStoreSearch);
      } else {
        console.error("StoreUpdator: #store_update_search not found");
      }
    }
  
    setCurrentStoreDetails() {
      if (!window.stores) {
        console.error("StoreUpdator: window.stores is undefined");
        return;
      }
  
      const matchedStore = Object.values(window.stores).find(
        (store) => store.store_id === this.current_store_id
      );
  
      if (!matchedStore) {
        console.warn("StoreUpdator: No matching store found");
        this.current_store_title.innerHTML = "Store not found";
        return;
      }
  
      this.current_store_title.innerHTML = matchedStore.title || "";
  
      // Handle distance
      const distance = localStorage.getItem('global_store_distance');
      if (distance && !isNaN(parseFloat(distance))) {
        const roundedDistance = this.roundToNearestHalf(parseFloat(distance));
        this.store_distance.innerHTML = `${roundedDistance} km away`;
      }
  
      // Handle address safely
      if (matchedStore.address) {
        const { street1 = "", city = "", province = "", zip = "", country = "" } = matchedStore.address;
        this.store_address.innerHTML = `${street1}, ${city}, ${province}, ${zip}, ${country}`.replace(/, ,|, $/g, "");
      }
  
      // Get and append nearest stores
      const nearestStores = this.getNearestStores(matchedStore);
      const storeContainer = document.querySelector('.nearby_stores');
      this.appendStoreElements(nearestStores, storeContainer);
  
      // Get and append nearest stores
      // const favouritetStores = this.getFavouriteStores(matchedStore);
      // const favouriteStoreContainer = document.querySelector('.favourite_stores');
      // this.appendStoreElements(nearestStores, favouriteStoreContainer);
    }

     getDistance(lat1, lon1, lat2, lon2) {
      const R = 6371; // Radius of the earth in km
      const dLat = (lat2 - lat1) * (Math.PI / 180);
      const dLon = (lon2 - lon1) * (Math.PI / 180);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c; // Distance in km
      return distance;
    }
  
    getNearestStores(matchedStore) {
      if (!matchedStore?.address) return [];
  
      const allStores = Object.values(window.stores).filter(store => store.store_id !== matchedStore.store_id);
      const { latitude, longitude } = matchedStore.address;
  
      return allStores
        .filter(({ address }) => address?.latitude && address?.longitude) // Ensure valid coordinates
        .map((store) => ({
          store,
          distance: this.getDistance(latitude, longitude, store.address.latitude, store.address.longitude),
        }))
        .sort((a, b) => a.distance - b.distance)
        .slice(0, 5);
    }
  
    getFavouriteStores(matchedStore) {
      if (!matchedStore?.address) return [];
  
      const allStores = Object.values(window.stores).filter(store => store.store_id === matchedStore.store_id);
      const { latitude, longitude } = matchedStore.address;
  
      return matchedStore
        .filter(({ address }) => address?.latitude && address?.longitude) // Ensure valid coordinates
        .map((store) => ({
          store,
          distance: this.getDistance(latitude, longitude, store.address.latitude, store.address.longitude),
        }))
        .sort((a, b) => a.distance - b.distance)
        .slice(0, 5);
    }
    
    appendStoreElements(nearestStores, storeContainer) {
      if (!storeContainer) {
        console.error("StoreUpdator: .nearby_stores container not found");
        return;
      }
  
      nearestStores.forEach(({ store, distance }) => {
        if (!store?.address) return;
        console.log(store, "Store")
  
        const hours = store.hours || "10am - 10pm";
        const [openingTime, closingTime] = hours.split(" - ");
  
        const image = store.img || 'https://cdn.shopify.com/s/files/1/0520/7713/4012/files/Generic_Store_Image_1.webp?v=1730910190';
  
        const storeOpenHour = this.convertTo24Hour(openingTime);
        const storeCloseHour = this.convertTo24Hour(closingTime);
        //const storeStatus = this.isStoreOpen(storeOpenHour, storeCloseHour);
        const storeStatus = this.isStoreOpenV2(store);
        
        let storeDelivery = "Pickup & Delivery";
        console.log(storeDelivery);
        if (store.has_pickup == false) { storeDelivery = storeDelivery.replace('Pickup &', ''); }
        if (store.has_delivery == false) {storeDelivery = storeDelivery.replace('& Delivery', ''); }
  
        const { street1 = "", city = "", province = "", zip = "", country = "", latitude = "", longitude = "" } = store.address;
  
        const storeElement = document.createElement('div');
        storeElement.classList.add('product__location-section', 'change__location-section');
        storeElement.innerHTML = `
          <section class="selected-store selected-store-ov">
            <div class="store-status">
              <img src="${image}" class="str-image">
              <div class="status-delivery">
                <span class="status ${storeStatus === "Open" ? "open" : "closed"}">${storeStatus}</span>
                <span class="status delivery">${storeDelivery}</span>
              </div>
            </div>
            <div class="current_address-location">
              <span class="current__location">${store.title}</span> | <span class="current__distance">${distance.toFixed(2)} km away</span>
              <div class="current__address">${street1}, ${city}, ${province}, ${zip}, ${country}</div>
            </div>
            <div class="store-info store-update_info">
              <button data-v="${store.store_id}" data-p="${province}" class="store-change-button">Shop Here</button>
              <a href="/pages/store/${store.handle}" class="store-details-button lol">Store Details</a>
            </div>
          </section>`;
  
        storeContainer.appendChild(storeElement);
      });
    }
  
    convertTo24Hour(timeStr) {
      if (!timeStr) return null;
      
      // Handle formats like "10am", "10:30am", "10 pm", "10:30 pm"
      const cleanTime = timeStr.trim().toLowerCase();
      const match = cleanTime.match(/(\d{1,2})(?::(\d{2}))?\s*(am|pm)/);
      
      if (!match) {
        console.warn('Invalid time format:', timeStr);
        return null;
      }
      
      let hour = parseInt(match[1], 10);
      const minutes = match[2] ? parseInt(match[2], 10) : 0;
      const period = match[3];
      
      // Convert to 24-hour format
      if (period === "pm" && hour !== 12) {
        hour += 12;
      } else if (period === "am" && hour === 12) {
        hour = 0;
      }
      
      // Return as decimal hours for more accurate comparison
      return hour + (minutes / 60);
    }
  
    isStoreOpenV2(store) {
      const now = new Date();
      //console.log(store.hours_periods.find(period => period.open.day === now.getDay()),"store");
      let todayHours ;
      if(typeof store.hours_periods != 'undefined')
      {
         todayHours  = store.hours_periods.find(period => period.open.day === now.getDay());
      }
    
      if (!todayHours) {
        return false;
      }
      console.log('Here');
      // const currentTime = parseInt(('0' + now.getHours()).slice(-2) + ('0' + now.getMinutes()).slice(-2), 10);
      const openTime  = parseInt(todayHours.open.time) / 100;
      const closeTime = parseInt(todayHours.close.time) / 100;
      const currentTime = new Date();
      const mstTime = new Date(currentTime.toLocaleString("en-US", { timeZone: "America/Denver" }));
      const currentHour = parseInt(mstTime.getHours());
      console.log(currentHour, openTime, closeTime, "Time");
    
      return currentHour >= openTime && currentHour < closeTime ? "Open" : "Closed";
    }
    isStoreOpen(openHour, closeHour) {
      if (openHour === null || closeHour === null) return "Closed";
      
      const currentTime = new Date();
      const mstTime = new Date(currentTime.toLocaleString("en-US", { timeZone: "America/Denver" }));
      const currentHour = mstTime.getHours();
      const currentMinutes = mstTime.getMinutes();
      
      // Convert current time to decimal hours for more accurate comparison
      const currentTimeDecimal = currentHour + (currentMinutes / 60);
      
      // Handle stores that close after midnight (e.g., 10pm - 2am)
      if (closeHour < openHour) {
        // Store closes the next day
        return (currentTimeDecimal >= openHour || currentTimeDecimal < closeHour) ? "Open" : "Closed";
      } else {
        // Normal case: store closes same day
        return currentTimeDecimal >= openHour && currentTimeDecimal < closeHour ? "Open" : "Closed";
      }
    }
  
    roundToNearestHalf(num) {
      return Math.round(num * 2) / 2;
    }
  
    handleStoreList() {
      const all_store_array = Object.values(window.stores).flat();
      const store_ids = [];
      this.store_list.innerHTML = "";
      all_store_array.forEach(store => {
            const { street1 = '', city = '', province = '', zip = '', country = '' } = store.address;
            const store_line_item = `${store.title} - ${city}, ${province} ${zip}`;
            const option = document.createElement('a');
            option.setAttribute('data-v', store.store_id);
            option.setAttribute('href', `/?sID=${store.store_id}`);
            option.textContent = store_line_item;
            option.setAttribute('data-p', store.address.province);
            
            // Add data attributes for enhanced search
            option.setAttribute('data-title', store.title || '');
            option.setAttribute('data-city', city);
            option.setAttribute('data-province', province);
            option.setAttribute('data-zip', zip);
            option.setAttribute('data-country', country);
            option.setAttribute('data-street', street1);
            option.setAttribute('data-full-address', `${street1}, ${city}, ${province}, ${zip}, ${country}`.replace(/, ,|, $/g, ""));
            
            this.store_list.appendChild(option);
            store_ids.push(store.store_id);
        });
      
    }
    
    handleStoreSearch(event) {
      const searchQuery = event.target.value.toLowerCase().trim();
      const links = this.store_list.querySelectorAll('a');

      if (searchQuery.length > 0) {
           this.store_dropdown.classList.add('active');
      } else {
          this.store_dropdown.classList.remove('active');
      }

      links.forEach(link => {
          // Get all searchable data from attributes
          const title = link.getAttribute('data-title') || '';
          const city = link.getAttribute('data-city') || '';
          const province = link.getAttribute('data-province') || '';
          const zip = link.getAttribute('data-zip') || '';
          const country = link.getAttribute('data-country') || '';
          const street = link.getAttribute('data-street') || '';
          const fullAddress = link.getAttribute('data-full-address') || '';
          
          // Create comprehensive search text
          const searchableText = `${title} ${city} ${province} ${zip} ${country} ${street} ${fullAddress}`.toLowerCase();
          
          // Normalize search query and text (replace special characters with spaces)
          const normalizedQuery = searchQuery.replace(/[^\w\s]/g, ' ').replace(/\s+/g, ' ').trim();
          const normalizedText = searchableText.replace(/[^\w\s]/g, ' ').replace(/\s+/g, ' ').trim();

          // Check if any part of the searchable text contains the query
          const isMatch = normalizedText.includes(normalizedQuery) || 
                         searchableText.includes(searchQuery) ||
                         // Also check individual components for partial matches
                         title.toLowerCase().includes(searchQuery) ||
                         city.toLowerCase().includes(searchQuery) ||
                         province.toLowerCase().includes(searchQuery) ||
                         zip.toLowerCase().includes(searchQuery) ||
                         street.toLowerCase().includes(searchQuery);

          if (isMatch) {
              link.style.display = ''; // Show link
          } else {
              link.style.display = 'none'; // Hide link
          }
      });
    }
    handleShopHere() {
    document.body.addEventListener('click', (event) => {
      if (event.target.classList.contains('store-change-button')) {
        event.preventDefault();
        this.updateStore(event.target);
      }
    });
  }
    handleStoreUpdate() {
       this.store_list.querySelectorAll('a').forEach((event) => {
        event.addEventListener('click', (event) => {
        event.preventDefault();
        const target = event.target;
          const store_Id = target.getAttribute('data-v');
          const province = target.getAttribute('data-p');
  
          const all_store_array = Object.values(window.stores).flat();
          const selectedStore = all_store_array.find(store => store.store_id === store_Id);
          if (selectedStore) {
              localStorage.setItem('global_store_id', store_Id);
              localStorage.setItem('global_province', province);
              this.clearCart().then(() => {
                const currentUrl = new URL(window.location.href);
                  currentUrl.searchParams.set('sID', store_Id);
                  console.log(currentUrl,"currentUrl");
                  window.location.href = currentUrl.toString();
            });
          }
  
        })  
        
      });
    }
  
    updateStore(target) {
      const store_Id = target.getAttribute('data-v');
      const province = target.getAttribute('data-p');
  
      const selectedStore = Object.values(window.stores).find(store => store.store_id === store_Id);
      if (selectedStore) {
        localStorage.setItem('global_store_id', store_Id);
        localStorage.setItem('global_province', province);
        this.clearCart().then(() => {
            const url = new URL(window.location.href);
            url.searchParams.set('sID', store_Id);
            const newUrl = url.toString();
            window.location.href = newUrl;
        });
      }
    }
    
    async clearCart() {
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
  
        if (!response.ok) {
          throw new Error('Network response was not ok.');
        }
  
        const data = await response.json();
        console.log('Cart cleared:', data);
      } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
      }
    }
    
  }
  
  customElements.define("store-updator", StoreUpdator);
  